module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0062.jpg?v=0d395e77";